export enum TagsStyles {
  SUCCESS = "success",
  INFO = "info" ,
  WARNING = "warning",
  DANGER = "danger",
  SECONDARY = "secondary",
  CONTRAST=  "contrast"
}
